// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WhyCompany_wrapper__QUwE4","content":"WhyCompany_content__9pxNc","contentTitle":"WhyCompany_contentTitle__pCFoN","sections":"WhyCompany_sections__FjM3w"};